import useTranslation from 'next-translate/useTranslation';

import {
  Box,
  Grid,
  Icon,
  Link,
  LinkTranslatedStyledAsLink,
  Paper,
  Typography,
} from '@core/component';
import { Translate, bookACallUrl } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useLanguage } from '@core/hook';
import {
  EActionAttribute,
  EColor,
  EIcon,
  ELinkAnimation,
  EPosition,
  ERouting,
  ETypographyVariant,
} from '@core/type';

import { useContextCrisp } from '@crisp';

import { LinkCardProps } from '../interface-contact';

export const LinkCardsSection = () => {
  const { isPhone } = useContextMediaQuery();
  const { language } = useLanguage();
  const { openChat } = useContextCrisp();

  const { t: tContact } = useTranslation(Translate.page.CONTACT);

  const bookACall = bookACallUrl[language];

  return (
    <Box marginBottom={'104px'}>
      {/* eslint-disable-next-line @typescript-eslint/no-magic-numbers */}
      <Grid spacing={isPhone ? 24 : 48} isContainer>
        <Grid xs={12} md={6} lg={4}>
          <Link as={EActionAttribute.BUTTON} onClick={openChat}>
            <LinkCard
              title={tContact('quickQuestion')}
              description={tContact('chatInRealTime')}
              label={tContact('availableAnytime')}
              iconType={EIcon.CHAT_WITH_TEXT}
              linkText={tContact('openLiveChatLink')}
            />
          </Link>
        </Grid>
        <Grid xs={12} md={6} lg={4}>
          <Link href={bookACall} target={'_blank'}>
            <LinkCard
              title={tContact('lookingToInvest')}
              description={tContact('bookACall')}
              label={tContact('weCallYouBack')}
              iconType={EIcon.PHONE2}
              linkText={tContact('bookACallLink')}
            />
          </Link>
        </Grid>
        <Grid xs={12} md={6} lg={4}>
          <LinkTranslatedStyledAsLink keyRoute={ERouting.CONTACT_FORM}>
            <LinkCard
              title={tContact('aBiggerQuestion')}
              description={tContact('contactOurTeam')}
              label={tContact('weReply')}
              iconType={EIcon.DOCUMENT}
              linkText={tContact('accessContactFormLink')}
            />
          </LinkTranslatedStyledAsLink>
        </Grid>
      </Grid>
    </Box>
  );
};

const LinkCard = ({ title, description, label, iconType, linkText }: LinkCardProps) => (
  <Paper
    display={'flex'}
    flexDirection={'column'}
    height={'100%'}
    overflow={'hidden'}
    boxShadow={EColor.ELEVATION_2}
  >
    <Box
      padding={'12px 12px 11px'}
      backgroundColor={{ semanticType: EColor.SECONDARY, variant: EColor.LIGHT }}
    >
      <Typography
        variant={ETypographyVariant.CAPTION1}
        color={EColor.SECONDARY}
        textAlign={'center'}
      >
        {label}
      </Typography>
    </Box>
    <Box
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      padding={'28px 30px'}
    >
      <Box>
        <Icon
          type={iconType}
          height={'35px'}
          width={'35px'}
          margin={'0 auto 16px'}
          marginBottom={'16px'}
        />
        <Typography as={EActionAttribute.H2} variant={ETypographyVariant.H5} marginBottom={'8px'}>
          {title}
        </Typography>
        <Typography marginBottom={'16px'}>{description}</Typography>
      </Box>
      <Box textAlign={'right'}>
        <Link
          as={EActionAttribute.SPAN}
          variant={ETypographyVariant.BODY3}
          color={EColor.ACCENT}
          endIcon={EIcon.ARROW_DOWN}
          iconPosition={EPosition.RIGHT}
          animation={ELinkAnimation.ARROW_RIGHT}
          iconOrientation={EPosition.RIGHT}
          isIconStroke
        >
          {linkText}
        </Link>
      </Box>
    </Box>
  </Paper>
);
